import angular from 'angular';
import 'angular-moment';
// import 'fullcalendar/main.js';
// import 'fullcalendar/main.css';
// import 'fullcalendar/dist/fullcalendar.js';
// import 'fullcalendar/dist/fullcalendar.css';
// import 'angular-fullcalendar';
// import '../../../../../vendor/angular-fullcalendar/dist/angular-fullcalendar';

import tooltip from 'angular-ui-bootstrap/src/tooltip';
import './angular-fullcalendar-directive';


// Translations
import translation from '../../../../../lib/translation';

// Load all services
import '../../../../../lib/service';

// Dependencies
import availabilityModal from '../availabilityModal';
import errorModalModule from '../../../../../lib/components/modals/errorModal';

// Component
import component from './fullCalendar.component';

const moduleName = 'staff.dashboardScreen.fullCalendar';
let module = angular.module(moduleName, [
  translation,
  'angular-fullcalendar',
  'angularMoment',
  tooltip,
  availabilityModal.name,
  errorModalModule.name,
]);

module.component('fullCalendar', component);

export default module;
